import { useQuery } from '@tanstack/react-query';
import { projectService, Project } from '../services/project.service';
import { getProjectStatusCheck, type ProjectStatusCheckResponse } from '../services/projectStatusCheck.service';

export const projectKeys = {
  all: ['projects'] as const,
  lists: (filters?: any) => [...projectKeys.all, 'list', filters] as const,
  list: (filters?: any) => [...projectKeys.all, 'list', filters] as const,
  detail: (id: string) => [...projectKeys.all, 'detail', id] as const,
  statusCheck: (id: string) => [...projectKeys.all, 'status-check', id] as const,
};

export function useProjects(filters?: {
  project_status?: string;
  project_manager?: string;
  customer_id?: string;
  is_active?: boolean;
  search?: string;
}) {
  return useQuery<Project[]>({
    queryKey: projectKeys.list(filters),
    queryFn: () => projectService.getProjects(filters),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useProject(id: string) {
  return useQuery<Project>({
    queryKey: projectKeys.detail(id),
    queryFn: () => projectService.getProjectById(id),
    enabled: !!id,
  });
}

export function useProjectStatusCheck(id: string) {
  return useQuery<ProjectStatusCheckResponse>({
    queryKey: projectKeys.statusCheck(id),
    queryFn: () => getProjectStatusCheck(id),
    enabled: !!id,
  });
}

export type { Project };

